import React from 'react';
import type { Article } from '../../utils/articleApi';
import { getArticleCategoryList } from '../../utils/articleCategories';

interface ArticleCategoryBadgesProps {
  article: Article;
  /** 既存のピル用クラス（1カテゴリ想定の見た目を維持） */
  badgeClassName?: string;
}

/**
 * 記事カード等用。複数カテゴリは複数ピルで表示
 */
export default function ArticleCategoryBadges({
  article,
  badgeClassName = 'inline-block bg-[#14B8A6] text-white px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-medium',
}: ArticleCategoryBadgesProps) {
  const labels = getArticleCategoryList(article);
  if (labels.length === 0) {
    return null;
  }
  return (
    <div className="flex flex-wrap items-center gap-1 sm:gap-2">
      {labels.map((label) => (
        <span key={label} className={badgeClassName}>
          {label}
        </span>
      ))}
    </div>
  );
}
